import { render, staticRenderFns } from "./WtTabBar.vue?vue&type=template&id=518b3958&scoped=true&"
import script from "./WtTabBar.vue?vue&type=script&lang=ts&"
export * from "./WtTabBar.vue?vue&type=script&lang=ts&"
import style0 from "./WtTabBar.vue?vue&type=style&index=0&id=518b3958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b3958",
  null
  
)

export default component.exports